module.exports = __webpack_public_path__ + "img/undraw_slider_5bgj.0e35b9df.svg";